import { Alert, Button, Col, Form, Row, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import {
  API_BASE_URL,
  CREATE_SPECIALITY,
  directToken,
  LIST_OF_HOSPITAL,
  LIST_OF_MASTER_SPECIALITY,
} from "../services/end_points";
import { _get } from "../services/service_api";
import axios from "axios";
const { Option } = Select;
const AddAssignSpeciality = ({ updateUserList }) => {
  const [formData, setFormData] = useState({
    hospitalId: "",
    specialityId: "",
  });
  const userId = localStorage.getItem("userid");

  const [hospitalOption, setHospitalOption] = useState([]);
  const [specialityOption, setSpecialityOption] = useState([]);
  const [alert, setAlert] = useState(false);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    getHospital();
    getSpeciality();
  }, []);

  const getHospital = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        directToken
      );
      const data = response.data;

      if (data.list && Array.isArray(data.list)) {
        setHospitalOption(
          data.list.map((source) => ({
            label: source.hospitalName,
            value: source.id,
          }))
        );
      } else {
        console.error("List not found in the response data");
      }
    } catch (error) {
      console.error("Error fetching hospitals:", error);
    }
  };

  const getSpeciality = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/${LIST_OF_MASTER_SPECIALITY}`
      );
      const data = response.data;
      if (data.list && Array.isArray(data.list)) {
        setSpecialityOption(
          data.list.map((source) => ({
            label: source.specialities_names,
            value: source.id,
          }))
        );
      } else {
        console.error("List not found in the response data");
      }
    } catch (error) {
      console.error("Error fetching specialities:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_BASE_URL}${CREATE_SPECIALITY}`,
        formData
      );
      updateUserList(response.data);
      setFormData({
        hospitalId: "",
        specialityId: "",
      });
      if (response.status === 201) {
        setAlert(true);
      }
    } catch (err) {
      console.error(err);
      setAlert(false);
    }
  };

  return (
    <>
      <div style={{ width: "25rem" }}>
        {alert && (
          <div marginBottom="20px">
            <Alert
              type="success"
              style={{
                backgroundColor: "#dff0d8",
                color: "green",
                fontSize: "16px",
                borderColor: "#dff0d8",
                textAlign: "center",
              }}
              message={"Speciality Created!"}
            />
          </div>
        )}

        <Row>
          <Col xl={24} md={16} lg={20} sm={24}>
            <Row gutter={[12, 12]} style={{ marginTop: "20px" }}>
              <Col xl={12} lg={12} md={12} sm={24}>
                <Form.Item
                  label="Select Hospital"
                  required
                  labelCol={{ span: 24 }} // Ensures the label takes full width
                  wrapperCol={{ span: 24 }} // Ensures the input takes full width
                >
                  <Select
                    showSearch
                    style={{
                      width: "100%", // Set width to 100% for better flexibility
                      height: "40px",
                      fontSize: "14px",
                    }}
                    value={formData.hospitalId || undefined}
                    onChange={(value) =>
                      setFormData({ ...formData, hospitalId: value })
                    }
                    filterOption={(input, option) => {
                      const label = option.children || "";
                      return label.toLowerCase().includes(input.toLowerCase());
                    }}
                    dropdownRender={(menu) => <div>{menu}</div>}
                  >
                    {hospitalOption.length > 0 ? (
                      hospitalOption.map((option) => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>No hospitals available</Option>
                    )}
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={12} lg={12} md={12} sm={24}>
                <Form.Item
                  label="Select Speciality"
                  required
                  labelCol={{ span: 24 }} // Ensures the label takes full width
                  wrapperCol={{ span: 24 }} // Ensures the input takes full width
                >
                  <Select
                    showSearch
                    style={{
                      width: "100%", // Set width to 100% for better flexibility
                      height: "40px",
                      fontSize: "14px",
                    }}
                    value={formData.specialityId || undefined}
                    onChange={(value) =>
                      setFormData({ ...formData, specialityId: value })
                    }
                    filterOption={(input, option) => {
                      const label = option.children || "";
                      return label.toLowerCase().includes(input.toLowerCase());
                    }}
                    // dropdownStyle={{ maxHeight: "130px", overflowY: "auto" }}
                  >
                    {specialityOption.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
              }}
            >
              <Button
                type="reset"
                onClick={() =>
                  setFormData({ hospitalId: "", specialityId: "" })
                }
                style={{
                  color: "black",
                  border: "solid blue",
                  width: "6vw",
                  borderRadius: "1vw",
                }}
              >
                Reset
              </Button>
              <Button
                type="submit"
                style={{
                  color: "white",
                  background: "#1677ff",
                  width: "6vw",
                  borderRadius: "1vw",
                }}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddAssignSpeciality;
